// jshint esversion: 8
export default {
  byType: state => type => state.data.find(template => template.type === type)
};
